module.exports = __webpack_public_path__ + "static/media/academyLogo.1a6cbab7.jpeg";